import React, { useState } from 'react';

import {
  ArrowUpIcon,
  CartIcon,
  ContainerResume,
  ContainerTotal,
  ContainerValues,
  ExpandResumePurchase,
  GrayLine,
  ImageCourse,
  PurchaseCheckout,
} from './style';

import arrowUpIconSVG from '../../../../../../assets/images/subscripiton-checkout-icons/arrow-up-icon.svg';
import cartIconSVG from '../../../../../../assets/images/subscripiton-checkout-icons/cart-icon.svg';

type Props = {
  planData: {
    id: number;
    planId: string;
    planImage: string;
    planImageDiscount: string;
    planName: string;
    originalPrice: number;
    price: number;
    discountPrice: number;
  };
  subInfoData: {
    isActive: number;
    planName: string | null;
    planId: string | null;
    createdAt: string | null;
    updatedAt: string | null;
  };
};

export function PurchaseResume({ planData, subInfoData }: Props): JSX.Element {
  const [expandResume, setExpandResume] = useState(true);

  const getPlanInfo = (): { originalPrice: number; price: number; planImage: string } => {
    if (subInfoData?.planName === null && planData?.planName === 'Plano Básico Completo Anual') {
      return {
        originalPrice: planData.originalPrice,
        price: planData.discountPrice,
        planImage: planData.planImageDiscount,
      };
    }

    return {
      originalPrice: planData.originalPrice,
      price: planData.price,
      planImage: planData.planImage,
    };
  };

  const planInfo = getPlanInfo();

  return (
    <ContainerResume>
      <ExpandResumePurchase
        onClick={() => {
          setExpandResume(!expandResume);
        }}
      >
        <CartIcon src={cartIconSVG} alt="Ícone de carrinho de compras" />
        <p>{expandResume ? 'Ocultar resumo da compra' : 'Exibir resumo da compra'}</p>
        <ArrowUpIcon
          src={arrowUpIconSVG}
          alt="Ícone de seta para cima, indicando ocultar o resumo da compra"
          transform={expandResume ? '' : 'scaleY(-1)'}
        />
      </ExpandResumePurchase>
      <PurchaseCheckout>
        {expandResume && <ImageCourse backImage={planInfo.planImage} />}
        {expandResume && <GrayLine />}
        <ContainerTotal>
          <h4>Total</h4>
          <ContainerValues>
            <span>
              {(planInfo.originalPrice / 100).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </span>
            <p>
              {(planInfo.price / 100).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </p>
          </ContainerValues>
        </ContainerTotal>
      </PurchaseCheckout>
      <GrayLine />
    </ContainerResume>
  );
}
